/**
 * Created by ronmarsiano on 14/02/2018.
 */
/**
 * Created by ronmarsiano on 06/02/2018.
 */
mainApp.directive('bandwidthConfig', function() {
    return {
        templateUrl: '/public/directives/bandwidthConfig.html',
        scope: {
            prefix: "@",
            hideTitle: "=?",
            bandwidthConfiguration: '=',
        },
        controller:  ['$scope', function($scope) {
        }]
    };
});